import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';
import { installLb3TestApi } from './app/testing/lb3-test-api';

console.log(`%c${environment.brand.title} v${environment.version} (dev: ${!environment.production})`, 'color: #007bff; font-weight: bold; padding: 5px;');

bootstrapApplication(App, appConfig)
  .then(appRef => {
    if (!environment.production) {
      installLb3TestApi(appRef.injector);
    }
  })
  .catch((err) => console.error(err));
